import Component from '../../../shared/component';

export default class ConversationSelect extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$conversations = this.$element.find('.conversationList-item-link');

    this.currentPageFormat = this.checkPageFormat();
    this.oldPageFormat = this.currentPageFormat;

    if (window.$window.width() > window.pageContentWidthMd) {
      this.bindTimeouts();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.handleResize = this.handleResize.bind(this);

    window.$window.on('resize.ConversationSelect', this.handleResize);
  }

  unbindEvents() {
    window.$window.off('resize.ConversationSelect', this.handleResize);
  }

  bindTimeouts() {
    setTimeout(() => this.loadConversation(), 0);
  }

  loadConversation() {
    if (this.$conversations.length > 0) {
      window.Turbolinks.visit(this.$conversations.first().attr('href'));
    }
  }

  handleResize() {
    this.checkPageFormat();

    if (
      this.currentPageFormat === 'desktop' &&
      this.oldPageFormat !== this.currentPageFormat
    ) {
      this.bindTimeouts();
    }
  }

  checkPageFormat() {
    this.oldPageFormat = this.currentPageFormat;

    if (window.$window.width() > window.pageContentWidthMd) {
      this.currentPageFormat = 'desktop';
    } else {
      this.currentPageFormat = 'mobile';
    }
  }
}
